import { defineStore } from 'pinia'
import { getUnreadNotificationCount } from '~/apis/notification'

export const useNotificationStore = defineStore('notificationStore', () => {
  const unreadCount = ref(0)
  const isLoading = ref(false)

  // 获取未读通知数量
  const fetchUnreadCount = async () => {
    try {
      isLoading.value = true
      const res = await getUnreadNotificationCount({
        loading: false,
        showSuccess: false
      })
      if (res.success && typeof res.data === 'number') {
        unreadCount.value = res.data
      }
    } catch (error) {
      console.error('Failed to fetch unread notification count:', error)
      // 出错时不更新数量，保持原有值
    } finally {
      isLoading.value = false
    }
  }

  // 重置未读数量（例如：用户查看通知后）
  const resetUnreadCount = () => {
    unreadCount.value = 0
  }

  // 减少未读数量（例如：标记单个通知为已读）
  const decreaseUnreadCount = (count: number = 1) => {
    unreadCount.value = Math.max(0, unreadCount.value - count)
  }

  return {
    unreadCount,
    isLoading,
    fetchUnreadCount,
    resetUnreadCount,
    decreaseUnreadCount
  }
})
